import React from 'react';
import Login from './Components/Login';
import Main from './Components/Main';



class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

      isLogin: false
    };


    this.tryLogin = this.tryLogin.bind(this);
  }

  componentDidMount() {

    var pass = localStorage.getItem("pass") || false;
    this.setState({ pass: pass });

  }

  tryLogin(pass) {
    var localPass = localStorage.getItem("pass") || false;
    if (!localPass) {
      var url = "http://46.175.145.158/";

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url + "mt-api.php", true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {

            var resp = JSON.parse(xhr.responseText);
            if (resp.status) {

              localStorage.setItem("name", resp.name);
              localStorage.setItem("dbname", resp.dbname);
              localStorage.setItem("url", resp.url);
              localStorage.setItem("skey", resp.skey);
              localStorage.setItem("pass", resp.pass);
              localStorage.setItem("globalGroup", resp.globalGroup);
              
              this.setState({ isLogin: true });

            } else {

              alert("Ошибка авторизации");
              this.setState({ isLogin: false });

            }

          } else {
            alert("Ошибка доступа к серверу авторизации");
            this.setState({ isLogin: false });
            console.error(xhr.statusText);
          }
        }
      }.bind(this);
      xhr.onerror = function (e) {
        console.error(xhr.statusText);
        alert("Ошибка доступа к серверу авторизации");
        this.setState({ isLogin: false });
      }.bind(this);
      xhr.send("id=0&pass=" + pass);
    } else {
      if (localPass == pass) {
        this.setState({ isLogin: true });
      } else {
        alert("Ошибка авторизации");
        this.setState({ isLogin: false });
      }
    }
  }

  render() {
    if (!this.state.isLogin) {
      return (<Login tryLogin={this.tryLogin} />);
    }
    else {
      return (<Main />);
    }

  }
}

export default App;
